exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#inspireLogin .el-tabs__content{\n  overflow: initial;\n}\n", ""]);

// exports
